import { Drawer } from '@any-ui-react/core';
import { useState } from 'react';
import { createPortal } from 'react-dom';

import { ActionMaterialIcon } from '@/common/components/shared/action-material-icon';
import { MaterialIcons } from '@/common/components/shared/material-icons';
import { QuickAccess } from '../quick-access';
import { NavigationLinks } from './NavigationLinks';
import { UserMenu } from './UserMenu';

export const TopNav = () => {
  const [isOpen, setOpen] = useState(false);
  const [isSearchOpen, setSearchOpen] = useState(false);

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between bg-white shadow-card print:hidden">
      <Drawer
        classNames={{ body: 'p-0', header: 'py-2 -mb-2' }}
        closeButtonProps={{ className: 'text-black' }}
        opened={isOpen}
        size="240px"
        title={
          <div className="flex" onClick={() => setOpen(false)}>
            <img alt="me" height="32" src="/anymind-logo.svg" width="122" />
            <img alt="me" className="p-1" height="15" src="/med-logo.svg" width="43" />
          </div>
        }
        onClose={() => setOpen(false)}
      >
        <NavigationLinks onLinkClick={() => setOpen(false)} />
      </Drawer>

      <button type="button" className="px-4 py-2" onClick={() => setOpen(true)}>
        <MaterialIcons iconName="dehaze" fontSize="22px" />
      </button>

      <div className="p-2">
        <div className="flex">
          <a className="flex" href="/">
            <img alt="me" height="32" src="/anymind-logo.svg" width="122" />
            <img alt="me" className="p-1" height="15" src="/med-logo.svg" width="43" />
          </a>
        </div>
      </div>

      <div className="flex items-center">
        <ActionMaterialIcon iconName="search" fontSize="22px" onClick={() => setSearchOpen(true)} />
        <UserMenu />
      </div>

      {isSearchOpen &&
        createPortal(
          <div
            className="fixed inset-0 z-50 flex flex-col items-center bg-black/50 pt-16"
            onClick={() => setSearchOpen(false)}
          >
            <div
              className="w-full max-w-lg overflow-hidden rounded-lg bg-white shadow-xl"
              onClick={e => e.stopPropagation()}
            >
              <QuickAccess autoFocus={true} onSelect={() => setSearchOpen(false)} />
            </div>
          </div>,
          document.body,
        )}
    </div>
  );
};
